/* Let's talk Decaf – Zusatzmodule (Präfix dlp): Tüten-Check-in Espresso/Filter, Mythen-Spiel,
   Rituale-Karussell, Filter-Rezepte mit Timer, Gieß-Spiel, Decaf Flight. Braucht decaf-lp.js (window.DLP). */
(function () {
  'use strict';

  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var NB = ' ';
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function H() { return window.DLP || {}; }
  function fmtT(s) { s = Math.max(0, Math.round(s)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
  function num(n) { return String(Math.round(n)); }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* egal */ }
  }

  /* ---------- Modus: welche Tüte? ---------- */
  var NAMES = { filter: 'Filter', espresso: 'Espresso' };
  function initMode(root, data) {
    if (!root.hasAttribute('data-dlp-dual')) return;
    var band = $('[data-dlp-checkin]', root), doneEl = $('[data-dlp-checkin-done]', root);
    var picks = $$('[data-dlp-pick]', root), sw = $('[data-dlp-mswitch]', root), swLabel = sw && $('[data-dlp-mswitch-label]', sw);
    var picked = root.hasAttribute('data-dlp-picked');
    var mode = root.getAttribute('data-dlp-mode');
    if (!picked) {
      var start = data.startMode;
      mode = (start === 'filter' || start === 'espresso') ? start : 'espresso';
      if (start === 'filter' || start === 'espresso') picked = true;
    }
    function sync(announce) {
      root.setAttribute('data-dlp-mode', mode);
      picks.forEach(function (b) {
        var on = picked && b.getAttribute('data-dlp-pick') === mode;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = (on || (!picked && b === picks[0])) ? 0 : -1;
      });
      if (band) band.classList.toggle('is-picked', picked);
      if (doneEl) {
        doneEl.textContent = picked ? (mode === 'filter'
          ? 'Lila heißt Filter. Kaufbox, Rezepte, Abo und Grownd-Tipps passen jetzt zu deiner Tüte.'
          : 'Blau heißt Espresso. Kaufbox, Brew Guide, Abo und Grownd-Tipps passen jetzt zu deiner Tüte.') : '';
      }
      if (sw) {
        var other = mode === 'filter' ? 'espresso' : 'filter';
        sw.setAttribute('data-mode', mode);
        sw.setAttribute('aria-label', 'Gerade: ' + NAMES[mode] + '. Zu ' + NAMES[other] + ' wechseln');
        if (swLabel) swLabel.textContent = NAMES[mode];
      }
      if (announce) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('bag', mode);
          window.history.replaceState(window.history.state, '', u.toString());
        } catch (e) { /* egal */ }
      }
      root.dispatchEvent(new CustomEvent('dlp:mode', { detail: { mode: mode } }));
    }
    function set(m) {
      if (m !== 'filter' && m !== 'espresso') return;
      var changed = m !== mode || !picked;
      mode = m; picked = true;
      sync(true);
      if (changed) track('decaf_bag_pick', { bag: m });
    }
    picks.forEach(function (b, i) {
      b.addEventListener('click', function () { set(b.getAttribute('data-dlp-pick')); });
      b.addEventListener('keydown', function (e) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
        e.preventDefault();
        var n = picks[(i + 1) % picks.length];
        set(n.getAttribute('data-dlp-pick'));
        n.focus();
      });
    });
    if (sw) {
      sw.addEventListener('click', function () { set(mode === 'filter' ? 'espresso' : 'filter'); });
      if (band && 'IntersectionObserver' in window) {
        var hideT = null;
        new IntersectionObserver(function (en) {
          var out = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          clearTimeout(hideT);
          if (out) { sw.hidden = false; requestAnimationFrame(function () { sw.classList.add('is-visible'); }); }
          else { sw.classList.remove('is-visible'); hideT = setTimeout(function () { if (!sw.classList.contains('is-visible')) sw.hidden = true; }, 350); }
        }, { threshold: 0 }).observe(band);
      }
    }
    sync(false);
  }

  /* ---------- Mythen: Wahr oder Kaffeesatz? ---------- */
  function initMyths(root) {
    var cards = $$('[data-dlp-myth]', root);
    if (!cards.length) return;
    var score = $('[data-dlp-myth-score]', root), total = cards.length, seen = 0, right = 0;
    function updateScore() {
      if (!score) return;
      var msg = '<b>' + seen + '</b> von ' + total + ' aufgedeckt';
      if (seen) msg += ' · ' + right + ' richtig getippt';
      if (seen === total) msg += right >= total - 1 ? '. Die Bohne ist beeindruckt.' : (right >= Math.ceil(total / 2) ? '. Gar nicht schlecht.' : '. Jetzt weißt du\'s.');
      score.innerHTML = msg;
    }
    cards.forEach(function (c) {
      var front = $('.dlp-myth__front', c), back = $('.dlp-myth__back', c), verdict = $('[data-dlp-verdict]', c);
      var answer = c.getAttribute('data-dlp-answer') === 'true';
      function flip(on) {
        c.classList.toggle('is-flipped', on);
        front.setAttribute('aria-hidden', on ? 'true' : 'false');
        back.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('button', front).forEach(function (b) { b.tabIndex = on ? -1 : 0; });
        $$('button', back).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      }
      $$('button', back).forEach(function (b) { b.tabIndex = -1; });
      $$('[data-dlp-guess]', c).forEach(function (b) {
        b.addEventListener('click', function () {
          var guess = b.getAttribute('data-dlp-guess') === 'true';
          var ok = guess === answer;
          if (!c.hasAttribute('data-done')) {
            c.setAttribute('data-done', '');
            seen++; if (ok) right++;
            updateScore();
          }
          c.classList.toggle('is-right', ok);
          c.classList.toggle('is-wrong', !ok);
          if (verdict) verdict.textContent = ok ? 'Richtig getippt.' : 'Knapp daneben.';
          flip(true);
          var again = $('[data-dlp-myth-back]', c);
          if (again) setTimeout(function () { again.focus({ preventScroll: true }); }, RM ? 0 : 450);
        });
      });
      var again = $('[data-dlp-myth-back]', c);
      if (again) again.addEventListener('click', function () {
        flip(false);
        var first = $('[data-dlp-guess]', c);
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, RM ? 0 : 450);
      });
    });
    updateScore();
  }

  /* ---------- Rituale: 3D-Karussell ---------- */
  function initRituals(root) {
    var sec = $('[data-dlp-rituals]', root);
    if (!sec) return;
    var ring = $('[data-dlp-ring]', sec), items = $$('[data-dlp-ritual]', sec), cards = $$('[data-dlp-ritual-card]', sec);
    var spin = $('[data-dlp-spin]', sec);
    if (!ring || !items.length) return;
    var n = items.length, step = 360 / n, rot = 0, cur = 0, busyT = null;
    function show(i) {
      cur = ((i % n) + n) % n;
      var key = items[cur].getAttribute('data-dlp-ritual');
      items.forEach(function (it, k) { it.classList.toggle('is-front', k === cur); it.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
      cards.forEach(function (c) { c.hidden = c.getAttribute('data-dlp-ritual-card') !== key; });
    }
    function turnTo(i, extraTurns) {
      var target = -i * step;
      var delta = ((target - rot) % 360 + 540) % 360 - 180; /* kürzester Weg */
      rot += delta - (extraTurns || 0) * 360;
      ring.style.setProperty('--rot', rot + 'deg');
      clearTimeout(busyT);
      if (RM) { show(i); return; }
      items.forEach(function (it) { it.classList.remove('is-front'); });
      busyT = setTimeout(function () { show(i); }, extraTurns ? 1500 : 650);
      if (!extraTurns) show(i);
    }
    items.forEach(function (it, i) {
      it.addEventListener('click', function () { turnTo(i, 0); });
    });
    if (spin) spin.addEventListener('click', function () {
      var next = cur;
      while (next === cur) next = Math.floor(Math.random() * n);
      ring.classList.add('is-spinning');
      turnTo(next, RM ? 0 : 2);
      setTimeout(function () { ring.classList.remove('is-spinning'); }, RM ? 0 : 1600);
      track('decaf_ritual_spin', {});
    });
    ring.style.setProperty('--n', n);
    show(0);
  }

  /* ---------- Filter: Rezepte, Timer, Story ---------- */
  var STORIES = {
    v60: ['V60, Handfilter', 'Der Name kommt von der Form: ein V-förmiger Kegel mit 60-Grad-Winkel.'],
    chemex: ['Chemex, seit 1941', 'Entworfen 1941 vom in Deutschland geborenen Chemiker Peter Schlumbohm. Heute steht die Chemex in der Sammlung des Museum of Modern Art in New York.'],
    fp: ['French Press, erstes Patent 1852', 'Ein erstes Patent für eine Vorform meldeten 1852 die Franzosen Mayer und Delforge an. 1929 meldeten die Italiener Attilio Calimani und Giulio Moneta eine Presskanne an, deren Sieb an der Kanne abschließt. Frankreich und Italien streiten bis heute, wem sie gehört.'],
    mm: ['Moccamaster, seit 1969', 'Entwickelt vom niederländischen Ingenieur Gerard Clement Smit. Seit 1969 auf dem Markt und bis heute in Amerongen in den Niederlanden gebaut. Mehrere Modelle sind von der SCA als Home Brewer zertifiziert.']
  };
  var FFIX = [
    ['Schmeckt sauer', 'Mahl etwas feiner, dann läuft es auch etwas länger. Gemahlen gekauft? Dann etwas heißer brühen oder langsamer gießen.'],
    ['Bitter oder trocken', 'Mahl etwas gröber. Gemahlen gekauft? Dann etwas kühler brühen oder zügiger gießen.'],
    ['Dünn, wässrig', 'Nimm etwas mehr Kaffee, zum Beispiel 1 g mehr pro Tasse.'],
    ['Zu kräftig', 'Nimm etwas weniger Kaffee oder etwas mehr Wasser.']
  ];
  function parseRecipe(txt) {
    var m = String(txt || '').match(/(\d+)\s*g[^\d]{0,12}?(\d{2,4})\s*g/i);
    var dose = 16, water = 250;
    if (m) { var d = +m[1], w = +m[2]; if (d >= 8 && d <= 40 && w >= 120 && w <= 700) { dose = d; water = w; } }
    return { dose: dose, water: water };
  }
  function initFilterBrew(root) {
    var box = $('[data-dlp-fbrew]', root);
    if (!box) return;
    var R = parseRecipe(box.getAttribute('data-recipe'));
    var DOSE = R.dose, WATER = R.water, RATIO = WATER / DOSE;
    var M = {
      v60: { name: 'Handfilter / V60', grind: 'mittel', temp: '92–96 °C', min: 1, max: 2, note: 'Rezept aus unserem Steckbrief: ' + DOSE + ' g Kaffee auf ' + WATER + ' g Wasser.',
        dose: function (c) { return DOSE * c; }, water: function (c) { return WATER * c; },
        steps: function (c) { var d = DOSE * c, w = WATER * c, b = Math.round(d * 2.5 / 5) * 5; return [[0, 'Bloom: ' + b + ' g Wasser, sodass alles nass ist. Einmal sanft schwenken.'], [40, 'Gleichmäßig auf ' + Math.round(w * 0.6 / 10) * 10 + ' g gießen.'], [70, 'Auf ' + w + ' g auffüllen, ruhig in Kreisen.'], [100, 'Einmal sanft schwenken, dann durchlaufen lassen.'], [c > 1 ? 210 : 150, 'Fertig. Ziel: ' + (c > 1 ? 'ca. 3:30' : 'ca. 2:30') + '.']]; } },
      chemex: { name: 'Chemex', grind: 'mittelgrob', temp: '92–96 °C', min: 2, max: 4, note: 'Startwert: 30 g Kaffee auf 500 g Wasser.',
        dose: function (c) { return 15 * c; }, water: function (c) { return 250 * c; },
        steps: function (c) { var d = 15 * c, w = 250 * c; return [[0, 'Bloom: ' + (d * 2) + ' g Wasser.'], [45, 'In Etappen auf ' + Math.round(w * 0.5 / 10) * 10 + ' g gießen.'], [105, 'Weiter auf ' + w + ' g gießen.'], [150, 'Durchlaufen lassen.'], [300, 'Fertig nach etwa 4:30 bis 5:30.']]; } },
      fp: { name: 'French Press', grind: 'grob', temp: '92–96 °C', min: 1, max: 4, note: 'Startwert: Verhältnis 1 : 16, vier Minuten ziehen lassen.',
        dose: function (c) { return Math.round(250 * c / 16); }, water: function (c) { return 250 * c; },
        steps: function (c) { return [[0, 'Alles Wasser (' + (250 * c) + ' g) auf den Kaffee gießen, Deckel drauf.'], [240, 'Kruste umrühren, Schaum abschöpfen.'], [270, 'Sieb langsam runterdrücken und gleich ausschenken.']]; } },
      mm: { name: 'Moccamaster / Filtermaschine', grind: 'mittel', temp: 'macht die Maschine', min: 2, max: 4, note: 'Startwert: 60 g Kaffee pro Liter Wasser.',
        dose: function (c) { return Math.round(250 * c * 0.06); }, water: function (c) { return 250 * c; },
        steps: function (c) { return [[0, (250 * c) + ' g Wasser in den Tank, ' + Math.round(250 * c * 0.06) + ' g Kaffee in den Filter, Maschine an.'], [300, 'Fertig nach etwa 4 bis 6 Minuten. Kanne kurz schwenken, dann einschenken.']]; } }
    };
    var gear = $$('[data-dlp-gear]', box), cur = 'v60', cups = 1, timer = null, t0 = 0, elapsed = 0;
    var el = {
      sh: $('[data-dlp-story-h]', box), st: $('[data-dlp-story-t]', box), name: $('[data-dlp-r-name]', box), note: $('[data-dlp-r-note]', box),
      cups: $('[data-dlp-cups-out]', box), dose: $('[data-dlp-r-dose]', box), water: $('[data-dlp-r-water]', box),
      grind: $('[data-dlp-r-grind]', box), temp: $('[data-dlp-r-temp]', box), clock: $('[data-dlp-clockout]', box),
      start: $('[data-dlp-t-start]', box), reset: $('[data-dlp-t-reset]', box), steps: $('[data-dlp-tsteps]', box)
    };
    function mark(s) {
      var lis = $$('li', el.steps), idx = -1;
      lis.forEach(function (li, i) { if (s >= +li.getAttribute('data-t')) idx = i; });
      lis.forEach(function (li, i) { li.classList.toggle('is-now', i === idx && timer !== null); li.classList.toggle('is-done', i < idx); });
    }
    function resetTimer() {
      if (timer) { clearInterval(timer); timer = null; }
      elapsed = 0; el.clock.textContent = '0:00'; el.start.textContent = 'Timer starten'; mark(-1);
    }
    function render() {
      var m = M[cur];
      cups = Math.max(m.min, Math.min(cups, m.max));
      el.sh.textContent = STORIES[cur][0];
      el.st.textContent = STORIES[cur][1];
      el.name.textContent = m.name;
      el.note.textContent = m.note;
      el.cups.textContent = cups + (cups > 1 ? ' Tassen' : ' Tasse');
      el.dose.textContent = m.dose(cups) + NB + 'g';
      el.water.textContent = m.water(cups) + NB + 'g';
      el.grind.textContent = m.grind;
      el.temp.textContent = m.temp;
      el.steps.innerHTML = m.steps(cups).map(function (s) { return '<li data-t="' + s[0] + '"><time>' + fmtT(s[0]) + '</time><span>' + s[1] + '</span></li>'; }).join('');
      mark(elapsed);
    }
    gear.forEach(function (g, i) {
      g.addEventListener('click', function () {
        cur = g.getAttribute('data-dlp-gear');
        gear.forEach(function (x) { var on = x === g; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; });
        resetTimer(); render();
      });
      g.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var nx = gear[(i + d + gear.length) % gear.length];
        nx.click(); nx.focus();
      });
      /* leichter 3D-Kipp beim Drüberfahren */
      if (!RM) {
        g.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          var r = g.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          g.style.setProperty('--rx', (-y * 14).toFixed(1) + 'deg');
          g.style.setProperty('--ry', (x * 18).toFixed(1) + 'deg');
        });
        g.addEventListener('pointerleave', function () { g.style.setProperty('--rx', '0deg'); g.style.setProperty('--ry', '0deg'); });
      }
    });
    $$('[data-dlp-cups]', box).forEach(function (b) {
      b.addEventListener('click', function () { cups += +b.getAttribute('data-dlp-cups'); resetTimer(); render(); });
    });
    el.start.addEventListener('click', function () {
      if (timer) { clearInterval(timer); timer = null; el.start.textContent = 'Weiter'; mark(elapsed); return; }
      t0 = Date.now() - elapsed * 1000;
      el.start.textContent = 'Pause';
      timer = setInterval(function () {
        elapsed = (Date.now() - t0) / 1000;
        el.clock.textContent = fmtT(elapsed);
        mark(elapsed);
      }, 250);
      track('decaf_timer_start', { method: cur });
    });
    el.reset.addEventListener('click', resetTimer);

    /* Wie schmeckt's? */
    var chips = $('[data-dlp-ffix]', box), out = $('[data-dlp-ffix-out]', box), DEF = out ? out.textContent : '';
    if (chips) FFIX.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = f[0]; b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        $$('button', chips).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (out) out.textContent = on ? f[1] : DEF;
      });
      chips.appendChild(b);
    });

    /* Mahlung aus der Kaufbox übernehmen: V60/Chemex/Frenchpress/Moccamaster -> passendes Gerät */
    var MAP = { v60: 'v60', chemex: 'chemex', frenchpress: 'fp', moccamaster: 'mm' };
    var form = $('[data-dlp-buy][data-dlp-set="filter"]', root);
    if (form) form.addEventListener('change', function () {
      var r = form.querySelector('input[type="radio"]:checked');
      var lab = r && r.parentNode.querySelector('[data-dlp-vlabel]');
      var g = lab ? String(lab.getAttribute('data-dlp-vlabel').split('|')[1] || '').toLowerCase().replace(/\s+/g, '') : '';
      if (MAP[g] && MAP[g] !== cur) { var t = $('[data-dlp-gear="' + MAP[g] + '"]', box); if (t) t.click(); }
    });

    render();
    initGame(box, DOSE, WATER, RATIO);
  }

  /* ---------- Gieß-Spiel „Psst. Don't wake the bean.“ ---------- */
  function initGame(box, DOSE, WATER) {
    var g = $('[data-dlp-game]', box);
    if (!g) return;
    function q(k) { return $('[data-dlp-g="' + k + '"]', g); }
    var stream = q('stream'), liquid = q('liquid'), bloomEl = q('bloom'), drip = q('drip'), cupEl = q('cup'), zz = q('zz');
    var say = q('say'), sayt = q('sayt'), hw = q('hw'), ht = q('ht'), noise = $$('i', q('noise')), pb = q('pour'), result = q('result');
    var steps = $$('li', q('steps'));
    var ABS = DOSE * 2, DRAIN = 1.9, G, raf = null, last = 0;
    function setStep(i) { steps.forEach(function (el, k) { el.classList.toggle('is-now', k === i); el.classList.toggle('is-done', k < i); }); }
    function setSay(t) { if (!t) { say.setAttribute('opacity', '0'); return; } sayt.textContent = t; say.setAttribute('opacity', '1'); }
    function reset() {
      G = { W: 0, L: 0, C: 0, t: 0, pouring: false, hold: 0, flow: 0, noise: 0, strikes: 0, bloomAmt: null, bloomEnd: null, bloomWait: null, loud: 0, started: false, over: false, overflow: false };
      result.hidden = true; result.innerHTML = ''; pb.textContent = 'Gedrückt halten zum Gießen'; pb.disabled = false;
      setSay(null); draw(); setStep(0);
    }
    function draw() {
      hw.textContent = num(G.W) + NB + 'g'; ht.textContent = fmtT(G.t);
      noise.forEach(function (el, k) { el.classList.toggle('is-on', G.noise > (k + 0.5) / 3); });
      stream.setAttribute('stroke-width', G.pouring ? Math.max(1.5, G.flow / 2.2) : 0);
      var lh = Math.min(66, G.L * 0.32);
      liquid.setAttribute('y', 140 - lh); liquid.setAttribute('height', lh); stream.setAttribute('y2', 140 - lh);
      var bl = (G.bloomAmt && G.bloomWait === null && G.t - G.bloomEnd < 45) ? Math.max(0, 14 - (G.t - G.bloomEnd) * 0.3) : 0;
      bloomEl.setAttribute('ry', bl);
      var ch = Math.min(60, G.C * 0.25 * 250 / WATER);
      cupEl.setAttribute('y', 278 - ch); cupEl.setAttribute('height', ch);
      drip.setAttribute('stroke-width', G.L > 0.5 ? 3 : 0);
      zz.setAttribute('opacity', G.strikes >= 3 ? 0 : 1);
    }
    function start(e) {
      if (e) e.preventDefault();
      if (G.over) return;
      G.pouring = true; G.hold = 0;
      if (!G.started) { G.started = true; track('decaf_pour_game', {}); }
      pb.classList.add('is-active');
      if (G.bloomEnd !== null && G.bloomWait === null) { G.bloomWait = G.t - G.bloomEnd; setStep(2); }
      if (!raf) { last = performance.now(); raf = requestAnimationFrame(tick); }
    }
    function end() {
      if (!G.pouring) return;
      G.pouring = false; G.flow = 0; pb.classList.remove('is-active');
      if (G.bloomAmt === null && G.W >= DOSE * 1.25) { G.bloomAmt = G.W; G.bloomEnd = G.t; setStep(1); }
    }
    function tick(now) {
      var dt = Math.min(0.05, (now - last) / 1000), dts = dt * 6;
      last = now;
      if (G.started && !G.over) {
        G.t += dts;
        if (G.pouring) {
          G.hold += dt; G.flow = Math.min(14, 3 + G.hold * 7.3);
          var add = G.flow * dts; G.W += add;
          var absorb = Math.max(0, Math.min(add, ABS - (G.W - add))); G.L += add - absorb;
          if (G.bloomAmt === null && G.W > DOSE * 3.75) { G.bloomAmt = -1; G.bloomEnd = G.t; G.bloomWait = 0; setStep(2); }
          if (G.flow > 9) G.noise += (G.flow - 9) / 5 * dt * 1.6; else G.noise = Math.max(0, G.noise - dt * 0.35);
          if (G.noise >= 1) {
            G.noise = 0.35; G.strikes++; G.loud++;
            setSay(G.strikes >= 3 ? 'Wer gießt hier so hektisch?' : (G.strikes === 2 ? 'Hmmm …' : 'Hm?'));
            if (G.strikes < 3) setTimeout(function () { if (!G.over) setSay(null); }, 1400);
            if (G.strikes >= 3) { wake(); return; }
          }
          if (G.W >= WATER - 10 && G.W < WATER + 30) setStep(3);
          if (G.W > WATER + 40) G.overflow = true;
        } else { G.noise = Math.max(0, G.noise - dt * 0.35); }
        var d = Math.min(G.L, DRAIN * dts); G.L -= d; G.C += d;
        if (!G.pouring && G.W >= WATER - 10 && G.L <= 0.3) { finish(); return; }
        if (G.t > 420) { finish(); return; }
      }
      draw(); raf = requestAnimationFrame(tick);
    }
    function stop() { G.over = true; cancelAnimationFrame(raf); raf = null; draw(); }
    function again() { var b = $('[data-dlp-g-again]', result); if (b) b.addEventListener('click', function () { reset(); pb.focus(); }); }
    function wake() {
      stop(); end();
      result.hidden = false;
      result.innerHTML = '<h4>Die Bohne ist wach.</h4><p>Zu viel Schwall auf einmal. Lass zwischendurch los, dann bleibt der Strahl ruhig.</p><button type="button" class="dlp-btn dlp-btn--ink" data-dlp-g-again>Nochmal, leiser</button>';
      pb.disabled = true; again();
    }
    function finish() {
      stop(); setStep(4);
      var okBloom = G.bloomAmt >= DOSE * 2 && G.bloomAmt <= DOSE * 3 && G.bloomWait !== null && G.bloomWait >= 27 && G.bloomWait <= 48;
      var okSteady = G.loud <= 1, okTime = G.t >= 135 && G.t <= 210, okWater = !G.overflow && G.W <= WATER + 25;
      var score = [okBloom, okSteady, okTime, okWater].filter(Boolean).length;
      var lo = DOSE * 2, hi = DOSE * 3;
      var bloomTxt = G.bloomAmt === -1 ? 'Bloom übersprungen: Lass nach ' + lo + '–' + hi + ' g kurz los.' :
        (okBloom ? 'Bloom sitzt: ' + num(G.bloomAmt) + ' g, ' + num(G.bloomWait) + ' s gewartet.' :
        'Bloom: ' + num(G.bloomAmt || 0) + ' g und ' + num(G.bloomWait || 0) + ' s. Ziel sind ' + lo + '–' + hi + ' g und 30–45 s.');
      var timeTxt = okTime ? 'Fertig nach ' + fmtT(G.t) + '. Genau im Fenster.' : (G.t < 135 ? 'Fertig nach ' + fmtT(G.t) + ', etwas schnell.' : 'Fertig nach ' + fmtT(G.t) + '. Gieß zügiger nach, wenn der Filter leerläuft.');
      result.hidden = false;
      result.innerHTML = '<h4>' + (score === 4 ? 'Perfekt. Die Bohne schläft weiter.' : score >= 2 ? 'Gut gebrüht. Fast lautlos.' : 'Die Bohne hat sich umgedreht.') + '</h4><ul>' +
        '<li class="' + (okBloom ? 'y' : 'n') + '">' + bloomTxt + '</li>' +
        '<li class="' + (okSteady ? 'y' : 'n') + '">' + (okSteady ? 'Gleichmäßig gegossen.' : 'Ein paar Mal zu hektisch.') + '</li>' +
        '<li class="' + (okTime ? 'y' : 'n') + '">' + timeTxt + '</li>' +
        (okWater ? '' : '<li class="n">' + num(G.W) + ' g Wasser, Ziel sind ' + WATER + ' g.</li>') +
        '</ul><div class="dlp-gresult__btns"><a class="dlp-btn dlp-btn--ink" href="#dlp-brew">Zum echten Rezept</a><button type="button" class="dlp-btn dlp-btn--line" data-dlp-g-again>Nochmal</button></div>';
      pb.disabled = true; again();
    }
    pb.addEventListener('pointerdown', function (e) { if (pb.setPointerCapture) pb.setPointerCapture(e.pointerId); start(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { pb.addEventListener(ev, end); });
    pb.addEventListener('keydown', function (e) { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); start(); } });
    pb.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); end(); } });
    pb.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    var lead = $('.dlp-game__intro p:last-child', g);
    if (lead) lead.textContent = 'Eine Tasse Handfilter nach unserem Rezept: ' + DOSE + ' g Kaffee, ' + WATER + ' g Wasser, rund zweieinhalb Minuten. Halte den Knopf gedrückt, um zu gießen. Je länger am Stück, desto kräftiger der Strahl. Wird es zu hektisch, wacht die Bohne auf. Die Uhr läuft sechsmal schneller.';
    var s1 = steps[0] && $('span', steps[0]);
    if (s1) s1.innerHTML = '<strong>Bloom:</strong> ' + (DOSE * 2) + '–' + (DOSE * 3) + ' g Wasser, also 2- bis 3-mal so viel wie Kaffee. Dann loslassen.';
    var s3 = steps[2] && $('span', steps[2]);
    if (s3) s3.innerHTML = '<strong>Gießen:</strong> gleichmäßig auf ' + WATER + ' g. Lieber zwei, drei ruhige Etappen als ein Schwall.';
    reset();
  }

  /* ---------- Decaf Flight ---------- */
  function initFlight(root, data) {
    $$('[data-dlp-flight]', root).forEach(function (box) {
      var raw = $('[data-dlp-flight-data]', box), list = [];
      try { list = JSON.parse(raw ? raw.textContent : '[]') || []; } catch (e) { list = []; }
      if (list.length < 2) { box.hidden = true; return; }
      var money = H().makeMoney ? H().makeMoney(data.currency) : function (c) { return (c / 100).toFixed(2).replace('.', ',') + NB + '€'; };
      var segs = $('[data-dlp-flight-grinds]', box), totalEl = $('[data-dlp-flight-total]', box);
      var btn = $('[data-dlp-flight-add]', box), st = $('[data-dlp-flight-status]', box);
      function key(g) { return String(g || '').trim().toLowerCase(); }
      function pick(prod, g) { return (prod.variants || []).filter(function (v) { return key(v.grind) === g; })[0] || null; }
      var grinds = [];
      (list[0].variants || []).forEach(function (v) {
        var g = key(v.grind);
        if (grinds.indexOf(g) < 0 && list.every(function (p) { return pick(p, g); })) grinds.push(g);
      });
      var label = {};
      (list[0].variants || []).forEach(function (v) { label[key(v.grind)] = v.grind; });
      var cur = grinds[0];
      function items() { return list.map(function (p) { return pick(p, cur); }); }
      function render() {
        var its = items(), ok = its.every(function (v) { return v && v.available; });
        if (H().segRender) {
          H().segRender(segs, grinds.map(function (g) {
            var avail = list.every(function (p) { var v = pick(p, g); return v && v.available; });
            return { value: g, label: H().grindLabel ? H().grindLabel(label[g], true) : label[g], disabled: !avail, title: 'Gerade nicht für alle drei verfügbar' };
          }), cur, function (val) { cur = val; render(); });
        }
        var sum = its.reduce(function (a, v) { return a + (v ? v.price : 0); }, 0);
        totalEl.textContent = money(sum);
        var unitEl = $('[data-dlp-flight-unit]', box);
        if (unitEl) unitEl.textContent = (ok && sum) ? ' (' + money(sum / 0.75) + '/kg)' : '';
        btn.disabled = !ok;
        btn.textContent = ok ? 'Alle drei in den Warenkorb' : 'Gerade nicht komplett verfügbar';
      }
      btn.addEventListener('click', function () {
        var its = items();
        if (!its.every(function (v) { return v && v.available; })) return;
        if (!H().cartAdd) return;
        H().busy(btn, true);
        H().cartAdd(its.map(function (v) { return { id: v.id, quantity: 1 }; }))
          .then(function (r) { H().done(st, r); track('decaf_flight_add', { set: box.getAttribute('data-dlp-set') }); })
          .catch(function (err) { H().fail(st, err); })
          .then(function () { H().busy(btn, false); });
      });
      if (!grinds.length) { box.hidden = true; return; }
      render();
    });
  }

  /* ---------- Start ---------- */
  function init(root) {
    if (root._dlpPlus) return;
    root._dlpPlus = true;
    var data = {};
    var raw = $('[data-dlp-data]', root);
    try { data = JSON.parse(raw ? raw.textContent : '{}') || {}; } catch (e) { data = {}; }
    [initMode, initMyths, initRituals, initFilterBrew, initFlight].forEach(function (fn) {
      try { fn(root, data); } catch (e) { if (window.console) console.error('[dlp-plus]', e); }
    });
  }
  function boot() { $$('[data-dlp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
